import { Button, Flex } from "antd";
import { FilterIcon } from "../../assets";
import { IconPrimary, Popup } from "../../components";
import FilterForm from "../../forms/FilterForm";
import { usePopup } from "../../hooks/usePopup";
import AppliedFilter from "../../forms/AppliedFilter";
import ATCVoucherTable from "./ATCVoucherTable";
import { useEffect, useState } from "react";
import ATCQuotation from "./ATCQuotation";
import ButtonSwitch from "../../components/ButtonSwitch";
import { FaPlus } from "react-icons/fa6";
import ATCVoucherForm from "../../forms/ATCVoucherForm";
import ATCQuotationForm from "../../forms/ATCQuotationForm";
import { useAppDispatch } from "../../redux/hooks";
import Select from "../../components/Select";
import axiosClient from "../../api/axiosClient";
import useUser from "../../hooks/useUser";

const buttons = ["Vouchers", "Quotation"];

export default function ATCVoucherManagement() {
  const [activeButton, setActiveBtn] = useState<string | null>("Vouchers");
  const popup = usePopup();
  const addPopup = usePopup();
  const dispatch = useAppDispatch();

  const [exams, setExams] = useState([]);

  const { user } = useUser();
  const isHaveEditPermission = user?.permissions?.includes("atc.edit");

  useEffect(() => {
    axiosClient
      .get("/exams/atc")
      .then((res) => setExams(res.data))
      .catch((err) => {});
  }, [dispatch]);

  return (
    <>
      <Flex gap="large" wrap="wrap">
        <ButtonSwitch
          buttons={buttons}
          onSwitch={(activeButton: string) => setActiveBtn(activeButton)}
        />
        <Popup
          ref={popup.popupRef}
          openTrigger={
            <Button icon={<FilterIcon style={{ marginTop: 2 }} />}>
              Filter
            </Button>
          }
        >
          <FilterForm
            popup={popup}
            extraFormItem={
              <>
                <div
                  className="full-width-divider"
                  style={{ marginBottom: 20 }}
                />
                <Select
                  options={exams}
                  placeholder={"Select Exam"}
                  formItemProps={{
                    name: "atc_id",
                    label: "Select Exam",
                    rules: [{ required: true, message: "Exam is required" }],
                  }}
                />
              </>
            }
          />
        </Popup>

        <AppliedFilter />

        {isHaveEditPermission ? (
          <Flex justify="end" flex={1}>
            <Popup
              ref={addPopup.popupRef}
              openTrigger={
                <IconPrimary>
                  <FaPlus color="white" />
                </IconPrimary>
              }
            >
              {activeButton === "Vouchers" ? (
                <ATCVoucherForm popup={addPopup} />
              ) : (
                <ATCQuotationForm popup={addPopup} />
              )}
            </Popup>
          </Flex>
        ) : (
          <Flex justify="end" flex={1}>
            <IconPrimary disabled={true}>
              <FaPlus color="white" />
            </IconPrimary>
          </Flex>
        )}
      </Flex>

      {activeButton === "Vouchers" ? <ATCVoucherTable /> : <ATCQuotation />}
    </>
  );
}
